
import req from '../utils/request.js'
// import config from '../utils/config.js'

const userapi = {}

// 个人馆藏列表
userapi.personsources = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/collection/getSelfCollection', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 移除馆藏申请
userapi.removesource = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/adks-app/removeapplyrecord/save', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 个人收藏列表
userapi.personcollections = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/collection/selfLikeCollection', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 收藏
userapi.addColleciton = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/adks-app/likecollection/collections', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 移除收藏
userapi.removecollection = function(params) {
  return new Promise((resolve, reject) => {
    req.post('/adks-app/likecollection/remove', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取个人信息
userapi.personinfo = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/user/info', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存个人信息
userapi.savepersoninfo = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/ha-base/user/personal/submit', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取用户学校信息
userapi.personschollinfo = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/blade-user_info/userinfo/getSelfSchool', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存用户学校信息
userapi.personschollinfoupdate = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/ha-base/blade-user_info/userinfo/updateSelfSchool', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 团体账号详情
userapi.teamuserInfo = function(params) {
  return new Promise((resolve, reject) => {
    req.get('/ha-base/blade-team_user/teamuser/getSelfTeam', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 团体账号头像修改
userapi.teamuserUpdate = function(params) {
  return new Promise((resolve, reject) => {
    req.postdata('/ha-base/team/update', params).then(res => {
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default userapi
